import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Box from "../../../../common/box/Box";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock, faFile } from "@fortawesome/free-solid-svg-icons";
import Tooltip from "../../../../common/tooltip/Tooltip";
import { mdiBallotRecountOutline } from "@mdi/js";
import Icon from "@mdi/react";
import CountdownTimer from "../CountdownTimer";
import { Row, Column } from "../../../../common/columns";
import { isDesktop } from "../../../../utils/screenUtil";
import { cleanJoin } from "../../../../utils/stringUtil";
import { getAccessToken } from "../../../../common/authorization/AuthorizeService";
import { useHistory } from "react-router-dom";

import "./ElectionDashboard.scss";
import "./ActiveElectionsSummaryPanel.scss";

function ElectionDashboard({ election, refresh, setRefresh }) {
  const [countdown, setCountdown] = useState({
    show: true,
    string: "",
    date: "",
    offset: "",
    refresh: false,
  });
  const [panelColor, setPanelColor] = useState("purple-dark");
  let docName = election?.cancellationFileUrl?.split("_user_");
  const history = useHistory();
  const { t } = useTranslation();
  const STATUS = {
    uPlaniranju: 1,
    zakljucano: 2,
    uTijeku: 3,
    zavrseno: 4,
    otkazano: 5,
  };

  useEffect(() => {
    let offset = new Date().getTime() - new Date(election.serverDate).getTime();
    let sad = new Date().getTime() + offset;
    let pocetak = new Date(election.dateTimeVotingStart);
    let kraj = new Date(election.dateTimeVotingEnd);

    if (
      election.generatedStatus.id === STATUS.uPlaniranju ||
      election.generatedStatus.id === STATUS.zakljucano
    ) {
      if (election.dateTimeVotingStart !== null && pocetak.getTime() > sad) {
        setCountdown({
          show: true,
          string: t("voting.countDownStart"),
          date: pocetak,
          offset: offset,
        });
        setPanelColor("purple-dark");
      } else {
        setCountdown({ show: false, string: "", date: "" });
        setPanelColor("purple-dark");
      }
    } else if (election.generatedStatus.id === STATUS.uTijeku) {
      setCountdown({
        show: true,
        string: t("voting.countDownEnd"),
        date: kraj,
        offset: offset,
      });

      setPanelColor("vote-green");
    } else if (election.generatedStatus.id === STATUS.zavrseno) {
      setCountdown(false);
      setPanelColor("vote-red");
    } else {
      setCountdown(false);
      setPanelColor("purple-dark");
    }
  }, [election]);

  const glasanje = () => {
    history.push(`/voting/${election.id}`);
  };

  const rezultati = () => {
    history.push(`/voting/${election.id}/results`, {
      title: election.typeName,
      status: election.generatedStatus.status,
      id: election.generatedStatus.id,
    });
  };

  const showCounterRow = () => {
    if (election.super) return true;
    else if (countdown.show) return true;
    else return false;
  };

  const showLockRow = () => {
    if (election.generatedStatus.id === STATUS.zakljucano) return true;
    else if (
      election.generatedStatus.id === STATUS.otkazano &&
      election.cancellationFileUrl !== null
    )
      return true;
    else return false;
  };

  return (
    <div>
      <Box
        className={cleanJoin(
          election.generatedStatus.id > STATUS.uPlaniranju &&
            election.generatedStatus.id < STATUS.otkazano
            ? "has-pointer-cursor"
            : "",
          "electionPanel my-5"
        )}
        statusIndicatorColor={panelColor}
        statusIndicatorPosition="bottom"
        isShadowless={false}
        defaultPadding={false}
        onClick={
          !election.super &&
          election.generatedStatus.id > STATUS.uPlaniranju &&
          election.generatedStatus.id < STATUS.otkazano
            ? glasanje
            : () => {}
        }
      >
        <div className="block">
          <Row className="mr-3" onClick={election.super ? glasanje : () => {}}>
            <Column className="is-three-quarters has-text-left mt-5">
              <span
                className={
                  election.generatedStatus.id !== STATUS.otkazano
                    ? `has-text-${panelColor} has-text-weight-bold `
                    : `has-text-grey has-text-weight-bold `
                }
              >
                {election.generatedStatus.id === STATUS.uTijeku ? "! " : ""}
                {election.generatedStatus.status}{" "}
                {election.generatedStatus.id === STATUS.otkazano
                  ? ` (${new Date(election.dateOfCancellation).toLocaleDateString("hr-HR")}) `
                  : ""}{" "}
                {" - "}
              </span>
              <span
                className={
                  election.generatedStatus.id !== STATUS.otkazano
                    ? "voting-details-link"
                    : "voting-details-link has-text-grey"
                }
              >
                {election.typeName}
              </span>
            </Column>
            <Column className="has-text-right mt-5">
              <span
                className={
                  election.generatedStatus.id !== STATUS.otkazano
                    ? `has-text-${panelColor} has-text-weight-bold `
                    : "has-text-grey has-text-weight-bold"
                }
              >
                {election.dateTimeVotingStart !== null
                  ? new Date(election.dateTimeVotingStart).toLocaleDateString("hr-HR")
                  : ""}
              </span>
            </Column>
          </Row>

          {showLockRow && (
            <Row className="mr-3 is-vcentered" onClick={election.super ? glasanje : () => {}}>
              {election?.generatedStatus.id === STATUS.zakljucano && (
                <Column
                  size={1}
                  className={cleanJoin(isDesktop() ? "" : "is-size-5", "has-text-left")}
                >
                  <Tooltip content={t("voting.electionsLock")}>
                    <FontAwesomeIcon icon={faLock} className={`has-text-purple-dark is-size-4`} />
                  </Tooltip>
                </Column>
              )}
              {election.generatedStatus.id === STATUS.otkazano &&
                election?.cancellationFileUrl !== null && (
                  <Column
                    size={1}
                    className={cleanJoin(isDesktop() ? "" : "is-size-5", "has-text-left")}
                  >
                    <Tooltip delay={0} content={docName[1]}>
                      <FontAwesomeIcon
                        icon={faFile}
                        className="is-size-4 ml-1 has-text-grey"
                        onClick={async () => {
                          fetch(
                            `${process.env.REACT_APP_GATEWAY_URL}${election?.cancellationFileUrl}`,
                            {
                              method: "GET",
                              headers: {
                                "Request-Origin": "portal",
                                Authorization: "Bearer " + (await getAccessToken()),
                              },
                              mode: "cors",
                              credentials: "include",
                            }
                          )
                            .then((response) => response.blob())
                            .then((file) => window.open(URL.createObjectURL(file)));
                        }}
                      />
                    </Tooltip>
                  </Column>
                )}
              <Column size={11}>
                {election.userVotingDate != null &&
                election.generatedStatus.id !== STATUS.otkazano ? (
                  <span /* className="ml-2 mt-0" */>{election.userVotingDate}</span>
                ) : (
                  <span>{""}</span>
                )}
              </Column>
            </Row>
          )}
          {showCounterRow && (
            <Row
              isGapless={true}
              className={cleanJoin(isDesktop() ? "is-flex is-justify-content-space-between" : "")}
            >
              <Column
                size={isDesktop() ? 8 : 6}
                className="my-auto"
                onClick={
                  election.super &&
                  election.generatedStatus.id > STATUS.zakljucano &&
                  election.generatedStatus < 5
                    ? glasanje
                    : () => {}
                }
              >
                {election.super &&
                  election.generatedStatus.id !== STATUS.otkazano &&
                  election.generatedStatus.id !== STATUS.uPlaniranju && (
                    <div>
                      <span className="is-size-7">
                        {election.registerVoters !== null &&
                          t("voting.totalVoters", { count: election.registerVoters })}
                      </span>
                      {election.generatedStatus.id > STATUS.zakljucano && (
                        <span>
                          <Icon
                            path={mdiBallotRecountOutline}
                            size={isDesktop() ? 2 : 1.3}
                            className={`has-text-vote-red mx-4`}
                            onClick={rezultati}
                          />
                        </span>
                      )}
                    </div>
                  )}
              </Column>
              <Column
                size={isDesktop() ? 4 : 6}
                className={isDesktop() ? "is-flex is-justify-content-flex-end" : ""}
                onClick={election.super ? glasanje : () => {}}
              >
                {countdown.show && (
                  <CountdownTimer
                    countdownTo={countdown.date}
                    offset={countdown.offset}
                    string={countdown.string}
                    refresh={refresh}
                    setRefresh={setRefresh}
                  />
                )}
              </Column>
            </Row>
          )}
        </div>
      </Box>
    </div>
  );
}

export default ElectionDashboard;
